"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _styles = require("@material-ui/core/styles");
var _clsx3 = _interopRequireDefault(require("clsx"));
var _useZoomPercentage = _interopRequireDefault(require("../hooks/useZoomPercentage"));
var _camelCase = _interopRequireDefault(require("../poly/camelCase"));
var _styles2 = require("../utilities/styles");
var _excluded = ["children", "classes", "value", "onChange", "indicatorType", "indicatorColor", "variant", "scrollColor"];
var useClasses = (0, _styles.makeStyles)(function (_ref) {
  var _lastTab;
  var breakpoints = _ref.breakpoints,
    highContrast = _ref.accessibility.highContrast,
    palette = _ref.palette,
    gutters = _ref.gutters;
  return {
    root: {
      width: '100%'
    },
    rootScrollable: (0, _defineProperty2.default)({
      '& .MuiTabScrollButton-root ~ .MuiTabs-scroller .MuiTabs-flexContainer': {
        justifyContent: 'flex-start !important'
      }
    }, breakpoints.down('xs'), {
      width: '100vw',
      overflow: 'visible',
      marginRight: "-".concat(gutters.page.xs),
      marginLeft: "-".concat(gutters.page.xs),
      '& .MuiTab-root:last-child': {
        marginRight: gutters.page.xs
      }
    }),
    flexContainer: (0, _defineProperty2.default)({}, breakpoints.up('md'), {
      justifyContent: 'center'
    }),
    defaultFixed: {
      borderBottom: "1px solid ".concat(palette.border.contrast)
    },
    defaultIndicator: (0, _defineProperty2.default)({
      height: '5px'
    }, highContrast.mediaQuery('active'), {
      display: 'none'
    }),
    defaultScrollable: (0, _defineProperty2.default)({
      borderBottom: "1px solid ".concat(palette.border.contrast),
      marginBottom: '0 !important'
    }, breakpoints.down('xs'), {
      display: 'flex'
    }),
    pillFixed: {
      borderBottom: 'none'
    },
    pillScrollable: (0, _defineProperty2.default)({
      borderBottom: 'none',
      marginBottom: '0 !important'
    }, breakpoints.down('xs'), {
      display: 'flex'
    }),
    pillIndicator: {
      display: 'none'
    },
    tabScrollButton: {
      '& svg': {
        fontSize: '2.5em'
      },
      '&:hover, &:focus': {
        color: function color(_ref2) {
          var scrollColor = _ref2.scrollColor;
          return !scrollColor ? palette.primary.main : scrollColor;
        },
        outline: "2px solid ".concat(palette.border.contrast)
      }
    },
    firstTab: (0, _defineProperty2.default)({}, breakpoints.down('xs'), {
      marginLeft: gutters.page.xs,
      '& > button:first-child': {
        marginLeft: 0
      }
    }),
    lastTab: (_lastTab = {}, (0, _defineProperty2.default)(_lastTab, breakpoints.down('xs'), {
      '& > button:last-child': {
        marginRight: 0
      }
    }), (0, _defineProperty2.default)(_lastTab, '&::after', {
      position: 'absolute',
      content: '""',
      height: '100%',
      paddingRight: gutters.page.xs
    }), _lastTab)
  };
}, {
  classNamePrefix: 'TCUITabs'
});
var convertChildren = function convertChildren(classes, children, onChange, value, variant, indicatorType, indicatorColor) {
  var numChildren = _react.default.Children.count(children);
  return _react.default.Children.map(children, function (child, childIndex) {
    var _clsx;
    if (! /*#__PURE__*/_react.default.isValidElement(child)) {
      return null;
    }
    if (process.env.NODE_ENV !== 'production') {
      if (child.type === _react.default.Fragment) {
        console.error(['Material-UI: the Tabs component doesn\'t accept a Fragment as a child.', 'Consider providing an array instead.'].join('\n'));
      }
    }
    var isFirstTab = childIndex === 0;
    var isLastTab = childIndex === numChildren - 1;
    return /*#__PURE__*/_react.default.cloneElement(child, {
      onChange: onChange,
      indicatorColor: indicatorColor,
      indicatorType: indicatorType,
      classes: (0, _styles2.mergeClasses)(child.props.classes, {
        root: (0, _clsx3.default)((_clsx = {}, (0, _defineProperty2.default)(_clsx, classes.firstTab, variant === 'scrollable' && isFirstTab), (0, _defineProperty2.default)(_clsx, classes.lastTab, variant === 'scrollable' && isLastTab), _clsx))
      }),
      fullWidth: variant === 'fullWidth',
      selected: (child.props.value || childIndex) === value
    });
  });
};
var Tabs = function Tabs(_ref3) {
  var children = _ref3.children,
    classes = _ref3.classes,
    value = _ref3.value,
    onChange = _ref3.onChange,
    indicatorType = _ref3.indicatorType,
    indicatorColor = _ref3.indicatorColor,
    variant = _ref3.variant,
    scrollColor = _ref3.scrollColor,
    rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  var theme = (0, _styles.useTheme)();
  var isMobile = (0, _useMediaQuery.default)(theme.breakpoints.down('xs'));
  var zoomPercentage = (0, _useZoomPercentage.default)();
  var _classes = useClasses({
    scrollColor: scrollColor
  });
  return /*#__PURE__*/_react.default.createElement(_core.Tabs, (0, _extends2.default)({
    scrollButtons: isMobile && zoomPercentage === 100 ? null : 'auto',
    variant: "scrollable"
  }, rest, {
    value: value,
    onChange: onChange,
    indicatorColor: indicatorColor,
    classes: (0, _styles2.mergeClasses)({
      root: (0, _clsx3.default)(_classes.root, _classes[(0, _camelCase.default)([indicatorType, 'root'])], (0, _defineProperty2.default)({}, _classes.rootScrollable, variant)),
      fixed: _classes[(0, _camelCase.default)([indicatorType, 'fixed'])],
      indicator: _classes[(0, _camelCase.default)([indicatorType, 'indicator'])],
      scrollable: _classes[(0, _camelCase.default)([indicatorType, 'scrollable'])],
      flexContainer: _classes.flexContainer
    }, classes),
    TabScrollButtonProps: {
      className: _classes.tabScrollButton,
      tabIndex: 0
    }
  }), convertChildren(_classes, children, onChange, value, variant || _variant, indicatorType, indicatorColor));
};
Tabs.propTypes = {
  children: _propTypes.default.node,
  classes: _propTypes.default.object,
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  variant: _propTypes.default.oneOf(['standard', 'scrollable', 'fullWidth']),
  onChange: _propTypes.default.func,
  indicatorType: _propTypes.default.oneOf(['default', 'pill']),
  indicatorColor: _propTypes.default.string,
  scrollColor: _propTypes.default.string
};
Tabs.defaultProps = {
  children: null,
  classes: {},
  value: null,
  onChange: function onChange() {
    return null;
  },
  indicatorColor: 'primary',
  indicatorType: 'default',
  variant: 'scrollable',
  scrollColor: null
};
var _default = Tabs;
exports.default = _default;